export default function SvgVolumeOff2() {
    return (
      <>
     <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      fill="#fff"
      viewBox="-4 0 32 32"
    >
      <path d="M24.3 4.592l-.742-.742-7.142 7.143V5.171l-7.687 6.127H2.78v4.743l-.003.003.003.003v4.693h3.889L.001 27.408l.742.742 7.41-7.41h.027l1.003-1.002-.015-.012 6.202-6.202v.027l1.049-1.049v-.027l7.883-7.883zM3.828 19.691v-7.343h5.268l6.271-4.998v3.949l.001.743-7.65 7.649H3.829zM15.368 19.691h-.001v4.901l-5.355-4.202-.747.747 7.151 5.611V20.74h.001v-6.755l-1.049 1.049z"></path>
    </svg>
    </>
    );
  }
